<template>
  <div class="s-confirmation-form__form">
    <form>
      <input
        v-for="(digit, index) in emailOtpLength"
        :key="index"
        :ref="`otpInput${index}`"
        v-model="emailOtpArray[index]"
        type="number"
        min="0"
        max="9"
        required
        class="form-control"
        :class="errorClass"
        autocomplete="off"
        :placeholder="placeholder"
        @focus="clearPlaceholder(index)"
        @blur="restorePlaceholder(index)"
        @input="focusNextInput($event, index)"
        @keyup="resetFormError($event, index)"
        @keydown="handleKeyDown($event, index)" />
    </form>
  </div>
</template>

<script>
import { nextTick } from 'vue'

export default {
  props: {
    hasOtpError: {
      default: false,
      type: Boolean,
    },
    resendOtpCode: {
      default: false,
      type: Boolean,
    },
  },
  emits: ['confirm-email-otp', 'reset-form'],
  data() {
    return {
      emailOtpLength: 6,
      emailOtpArray: [],
      placeholder: '•',
    }
  },
  computed: {
    emailOtpCode() {
      return Object.values(this.emailOtpArray).join('')

      // return this.emailOtpArray.map((v) => String(Object.values(v)[0])).join('')
      //return this.emailOtpArray.map((v) => Object.values(v)).join('')
    },
    errorClass() {
      return this.hasOtpError ? 'form-control--error' : ''
    },
  },
  watch: {
    resendOtpCode(newVal) {
      if (newVal) {
        this.emailOtpArray = []
      }
    },
  },

  methods: {
    clearPlaceholder(index) {
      this.$refs[`otpInput${index}`][0].placeholder = ''
    },

    restorePlaceholder(index) {
      if (!this.emailOtpArray[index]) {
        this.$refs[`otpInput${index}`][0].placeholder = '•'
      }
    },

    focusNextInput(event, index) {
      //const value = event.target.value.replace(/[^\d]/g, '')

      let value = this.emailOtpArray[index].toString().replace(/[^0-9]/g, '')
      this.emailOtpArray[index] = value.charAt(0) || '' // Keep only first digit

      if (!value) {
        // this.emailOtpArray[index] = ''
        console.log('1')
        this.emailOtpArray.splice(index, index)

        return false
      }
      if (event.target.value.length === 1 && index < this.emailOtpLength - 1) {
        this.$refs[`otpInput${index + 1}`][0].focus()
      }

      console.log('code from otp', this.emailOtpCode)
      this.$emit('confirm-email-otp', this.emailOtpCode)
    },

    resetFormError(event, index) {
      if (event.key === 'Backspace') {
        this.$emit('reset-form', this.emailOtpCode)
      }
    },

    handleKeyDown(event, index) {
      if (event.key === 'Backspace') {
        if (event.target.value.length === 0 && index > 0) {
          this.$refs[`otpInput${index - 1}`][0].focus()
        }
      }
    },
  },
}
</script>
